import { render, staticRenderFns } from "./page-job-candidate.vue?vue&type=template&id=c4d86506&"
import script from "./page-job-candidate.vue?vue&type=script&lang=js&"
export * from "./page-job-candidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports